export const snakeToCamel = (str) => {
  return str
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace("-", "").replace("_", "")
    );
};

export const sentenceToCamel = (str) => {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
};

export function camelToSentence(str) {
  if (!str) return;
  str = str.replace(/([A-Z])/g, " $1");
  str = str.toLowerCase().replace(/^./, (match) => match.toUpperCase());
  return str;
}

export function camelToName(str) {
  if (!str) return;
  const words = str.split(/(?=[A-Z])/);

  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  );

  const nameCaseString = capitalizedWords.join(" ");

  return nameCaseString;
}

export function capitalizeFirstLetter(str) {
  if (!str) return;
  const [firstLetter, ...rest] = str;
  return firstLetter.toUpperCase() + rest.join("");
}
